<form *ngIf="form as form" autocomplete="off" novalidate [formGroup]="form">
  <div class="row" formArrayName="items">
    <div class="col-12">
      <ol>
        @for (control of form.items.controls; track $index) {
          <li>
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class='col-10'>
                    <div class='form-group'>
                      <label [for]='"trunkCircumference130_" + $index'>
                        Obwód pnia <br> na wysokości 130 cm *
                      </label>
                      <input
                        (change)="itemChange.emit()"
                        [id]='"trunkCircumference130_" + $index'
                        [ngClass]='{ "is-invalid": !!control?.invalid && !!control?.touched }'
                        [formControl]='form.getControl($index)'
                        placeholder='Wpisz tu obwód pnia'
                        mask="0*"
                        type='text'>
                      <app-validation-errors [control]='control'>
                      </app-validation-errors>
                    </div>
                  </div>
                  <div class="col-2 d-flex align-items-center">
                    <button
                      [disabled]="$index === 0"
                      style="margin-top: 0.25rem"
                      (click)="form.onRemoveItem($index, $event); itemChange.emit()"
                      type="button"
                      class="btn btn-primary icon-btn">
                      <i aria-hidden="true" class="fa fa-minus"></i>
                      <span class="sr-only">usuń pozycję</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        }
      </ol>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <button
                style="width: 100%"
                (click)="form.onAddItem($event)"
                type="button"
                class="btn btn-secondary">
                <i aria-hidden="true" class="fa fa-plus"></i>Dodaj kolejny
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<br>
